import { RoutePath } from "#src/utils/route";
import { DataToolsRoutePath } from "..";

export const DataSubmissionsRoutePath = DataToolsRoutePath.concat(
  new RoutePath<string, "tab">({
    path: "/submissions",
    title: "Data Submissions",
  })
);
